// exam
const b1 = Array.from(Array(20).keys());
const b2 = Array.from(Array(18).keys());
const c = Array.from(Array(15).keys());
const d = Array.from(Array(14).keys());
const e = Array.from(Array(14).keys());
const f = Array.from(Array(14).keys());
const a1 = Array.from(Array(8).keys());
const a2 = Array.from(Array(18).keys());
const a3 = Array.from(Array(20).keys());
const a4 = Array.from(Array(20).keys());

// chapter
const chapterB1 = Array.from(Array(9).keys());
const chapterB2 = Array.from(Array(9).keys());
const chapterC = Array.from(Array(9).keys());
const chapterD = Array.from(Array(9).keys());
const chapterE = Array.from(Array(9).keys());
const chapterF = Array.from(Array(9).keys());
const chapterA1 = Array.from(Array(7).keys());
const chapterA2 = Array.from(Array(8).keys());
const chapterA3 = Array.from(Array(7).keys());
const chapterA4 = Array.from(Array(8).keys());

// examRandom
const b1Random = Array.from(Array(20).keys());
const b2Random = Array.from(Array(18).keys());
const cRandom = Array.from(Array(15).keys());
const dRandom = Array.from(Array(14).keys());
const eRandom = Array.from(Array(14).keys());
const fRandom = Array.from(Array(14).keys());
const a1Random = Array.from(Array(8).keys());
const a2Random = Array.from(Array(18).keys());
const a3Random = Array.from(Array(20).keys());
const a4Random = Array.from(Array(20).keys());

export const licenseDataArray = [[a1, a2, a3, a4, b1, b2, c, d, e, f], [chapterA1, chapterA2, chapterA3, chapterA4, chapterB1, chapterB2, chapterC, chapterD, chapterE, chapterF], [a1Random, a2Random, a3Random, a4Random, b1Random, b2Random, cRandom, dRandom, eRandom, fRandom], ["a1", "a2", "a3", "a4", "b1", "b2", "c", "d", "e", "f"], ["o-to", "xe-may"]];